/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShipmentState } from './ShipmentState';
import {
    ShipmentStateFromJSON,
    ShipmentStateFromJSONTyped,
    ShipmentStateToJSON,
    ShipmentStateToJSONTyped,
} from './ShipmentState';
import type { TrackingLine } from './TrackingLine';
import {
    TrackingLineFromJSON,
    TrackingLineFromJSONTyped,
    TrackingLineToJSON,
    TrackingLineToJSONTyped,
} from './TrackingLine';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * One shipment's summary within a multi-shipment tracking group. Carrier fields are absent for a shipment that has no selected quote yet.
 * @export
 * @interface TrackingGroupShipment
 */
export interface TrackingGroupShipment {
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    trId: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    billOfLadingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    proNumber?: string;
    /**
     * 
     * @type {ShipmentState}
     * @memberof TrackingGroupShipment
     */
    shipmentState: ShipmentState;
    /**
     * 
     * @type {Location}
     * @memberof TrackingGroupShipment
     */
    pickupLocation: Location;
    /**
     * 
     * @type {Location}
     * @memberof TrackingGroupShipment
     */
    deliveryLocation: Location;
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    pickupDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    expectedDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    actualDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    carrierIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingGroupShipment
     */
    serviceDisplayName?: string;
    /**
     * 
     * @type {TrackingLine}
     * @memberof TrackingGroupShipment
     */
    mostRecentTrackingLine?: TrackingLine;
}



/**
 * Check if a given object implements the TrackingGroupShipment interface.
 */
export function instanceOfTrackingGroupShipment(value: object): value is TrackingGroupShipment {
    if (!('trId' in value) || value['trId'] === undefined) return false;
    if (!('shipmentState' in value) || value['shipmentState'] === undefined) return false;
    if (!('pickupLocation' in value) || value['pickupLocation'] === undefined) return false;
    if (!('deliveryLocation' in value) || value['deliveryLocation'] === undefined) return false;
    return true;
}

export function TrackingGroupShipmentFromJSON(json: any): TrackingGroupShipment {
    return TrackingGroupShipmentFromJSONTyped(json, false);
}

export function TrackingGroupShipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingGroupShipment {
    if (json == null) {
        return json;
    }
    return {
        
        'trId': json['trId'],
        'billOfLadingNumber': json['billOfLadingNumber'] == null ? undefined : json['billOfLadingNumber'],
        'proNumber': json['proNumber'] == null ? undefined : json['proNumber'],
        'shipmentState': ShipmentStateFromJSON(json['shipmentState']),
        'pickupLocation': LocationFromJSON(json['pickupLocation']),
        'deliveryLocation': LocationFromJSON(json['deliveryLocation']),
        'pickupDate': json['pickupDate'] == null ? undefined : json['pickupDate'],
        'expectedDeliveryDate': json['expectedDeliveryDate'] == null ? undefined : json['expectedDeliveryDate'],
        'actualDeliveryDate': json['actualDeliveryDate'] == null ? undefined : json['actualDeliveryDate'],
        'carrierIdentifier': json['carrierIdentifier'] == null ? undefined : json['carrierIdentifier'],
        'serviceDisplayName': json['serviceDisplayName'] == null ? undefined : json['serviceDisplayName'],
        'mostRecentTrackingLine': json['mostRecentTrackingLine'] == null ? undefined : TrackingLineFromJSON(json['mostRecentTrackingLine']),
    };
}

  export function TrackingGroupShipmentToJSON(json: any): TrackingGroupShipment {
      return TrackingGroupShipmentToJSONTyped(json, false);
  }

  export function TrackingGroupShipmentToJSONTyped(value?: TrackingGroupShipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trId': value['trId'],
        'billOfLadingNumber': value['billOfLadingNumber'],
        'proNumber': value['proNumber'],
        'shipmentState': ShipmentStateToJSON(value['shipmentState']),
        'pickupLocation': LocationToJSON(value['pickupLocation']),
        'deliveryLocation': LocationToJSON(value['deliveryLocation']),
        'pickupDate': value['pickupDate'],
        'expectedDeliveryDate': value['expectedDeliveryDate'],
        'actualDeliveryDate': value['actualDeliveryDate'],
        'carrierIdentifier': value['carrierIdentifier'],
        'serviceDisplayName': value['serviceDisplayName'],
        'mostRecentTrackingLine': TrackingLineToJSON(value['mostRecentTrackingLine']),
    };
}

